import { FuelIcon } from '@frete.com/fuel-react'
import styled from 'styled-components'
import { DropDownProps } from './interfaces'

export const DropDown = styled.ul<DropDownProps>`
  display: ${({ $isOpened }) => ($isOpened ? 'block' : 'none')};
  position: absolute;
  text-align: left;
  background: ${({ theme }) => theme.color.background.neutral.default};
  border: ${({ theme }) => theme.border.width.thinner} ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.color.border.neutral.medium};
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.padding.km2} ${({ theme }) => theme.padding.km0};
  z-index: ${({ theme }) => theme.zIndex.absolute};
  box-shadow: 0px 8px 16px rgba(59, 64, 79, 0.18);
  height: fit-content;
  margin-top: 5px;
  width: ${({ $width }) => $width || 'fit-content'};
  right: ${({ $width }) => ($width ? '0' : '56px')};
`

export const Item = styled.li`
  color: ${({ theme }) => theme.color.text.neutral.default};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.medium};
  padding: ${({ theme }) => theme.padding.km3};
  list-style-type: none;
  cursor: pointer;

  :hover {
    background: ${({ theme }) => theme.color.background.neutral.weak};
  }
`

export const Icon = styled(FuelIcon)`
  top: 3px;
  padding-right: ${({ theme }) => theme.padding.km3};
`
